import {
  CarrierType,
  CreateNumericReleaseCommand,
  UpdateNumericReleaseCommand,
} from '@planning/app/api'
import { NumericReleaseItemStore } from '@planning/rt-stores/numericRelease/NumericReleaseItemStore'
import numericReleaseService from '@planning/services/numericReleaseService'
import { Dayjs } from 'dayjs'
import { computed, makeObservable } from 'mobx'
import { ReleaseControlViewStore } from './ReleaseControlViewStore'

export interface NumericReleaseFormData {
  referenceNumber: string
  shippingLineId: number
  amount: number
  modeOfTransport: CarrierType
  transportCompanyId?: number | null
  carrierVisitId: number | null
  validityDate?: Dayjs | null | undefined
}

export class NumericReleaseControlViewStore extends ReleaseControlViewStore<NumericReleaseFormData> {
  constructor(private numericReleaseItemStore: NumericReleaseItemStore) {
    super()
    makeObservable(this, {
      selectedNumericRelease: computed,
    })
  }

  get selectedNumericRelease() {
    return this.id ? this.numericReleaseItemStore.elements[this.id] : undefined
  }

  onSubmit = async (data: NumericReleaseFormData) => {
    // Temporary workaround: keep end-of-day instant as UTC timestamp and compare by full timestamp
    // across UI/API. This works when users operate in the same timezone as the port.
    // Future: if business switches to tenant/port-local calendar-day semantics, this flow must be
    // replaced with timezone-aware date-boundary conversion on both frontend and backend.
    if (this.isEditMode) {
      const cmd: UpdateNumericReleaseCommand = {
        ...data,
        id: this.id!,
        validityDate: data.validityDate?.toISOString(),
      }

      if (cmd.modeOfTransport === CarrierType.Truck) {
        cmd.carrierVisitId = undefined
      }

      await numericReleaseService.put(cmd)
    } else {
      const cmd: CreateNumericReleaseCommand = {
        ...data,
        validityDate: data.validityDate?.toISOString(),
      }

      await numericReleaseService.post(cmd)
    }
  }
}
